module.exports = __webpack_public_path__ + "img/crop_info_left_head.8533e648.png";